import nastyConfig from 'services/config/FormatConfig.json'
let formatter; let currentCurrency; let sign
const nastyCurrency = {
  needReplace: false,
  currentToReplace: '',
  isSignAtTheEnd: false,
}
const reg = /\d.+\d/

function init({ i18n = 'en', currency, lang }) {
  currentCurrency = currency
  const result = checkNasty()
  if (result) {
    currency = 'BRL'
  }

  const locale = (i18n || lang).split('-')[0]

  try {
    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
    })
  }
  catch(e) {
    currency = 'USD'

    nastyCurrency.needReplace = true
    nastyCurrency.currentToReplace = currentCurrency
    nastyCurrency.isSignAtTheEnd = true

    formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
    })
  }

  const sym = (currency, i18n) =>
    new Intl.NumberFormat(i18n, { style: 'currency', currency })
      .formatToParts(1)
      .find((x) => x.type === 'currency')
      .value

  sign  = sym(currency, locale)
}

function getCurrency() {
  return sign
}

function checkNasty(){
  const config = nastyConfig
  const curReplace =  config.currencyReplace
  if(curReplace.hasOwnProperty(currentCurrency)){
    nastyCurrency.needReplace = true
    nastyCurrency.currentToReplace = curReplace[currentCurrency]
    return true
  }
  return false
}

function formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
  decimalCount = Math.abs(decimalCount)
  decimalCount = isNaN(decimalCount) ? 2 : decimalCount

  let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
  let j = (i.length > 3) ? i.length % 3 : 0

  return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
}

function currency(value = 0, sign = true) {
  const out =  formatter.format(value / 100)
  let cur

  if (nastyCurrency.isSignAtTheEnd) {
    cur = nastyCurrency.needReplace
      ? `${value < 0 ? '-' : ''}${formatMoney(Math.abs(value) / 100)}${sign ? ' ' + nastyCurrency.currentToReplace : ''}`
      : sign
        ? out
        : checkFormat(out)
  }
  else {
    cur = nastyCurrency.needReplace ? `${value < 0 ? '-' : ''}${sign ? nastyCurrency.currentToReplace : ''}${formatMoney(value / 100)}` : sign ? out : checkFormat(out)
  }

  if(currentCurrency === 'YOH' && nastyCurrency.needReplace){
    cur = `${value < 0 ? '-' : ''}${sign ? '$' : ''}${formatMoney(value / 100)}${sign ? nastyCurrency.currentToReplace : ''}`
  }
  if(currentCurrency === 'TOK' && nastyCurrency.needReplace){
    cur = `${value < 0 ? '-' : ''}${formatMoney(value / 100)}${sign ? nastyCurrency.currentToReplace : ''}`
  }

  return cur
}
function checkFormat(value){
  const format = value.match(reg)
  if(format === null || format === undefined){
    return value
  }
  else{
    return value.match(reg)[0]
  }
}

export const FormatService = {
  init,
  currency,
  getCurrency,
}
